export default __webpack_public_path__ + "static/media/cakebROOBEE.38c54a56.png";